import _inject from "@stylexjs/stylex/lib/stylex-inject";
import React from 'react';
import * as stylex from '@stylexjs/stylex';
import { NavLink } from "react-router-dom";
import { queryStringMod } from "nood-comp/src/util/converters/converters";
import Icon from "nood-comp/src/comp/ui/feather-icon/Icon";
import Table from "nood-comp/src/comp/data/table/Table";
export default function Properties(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Table, {
    data_source: "/properties",
    cols: [{
      label: "ID",
      content: function content(prop) {
        return /*#__PURE__*/React.createElement(NavLink, {
          to: queryStringMod({
            "do": "view",
            id: prop.id
          })
        }, prop.id);
      }
    }, {
      property: "entity",
      filterType: 'text',
      icon: 'square'
    }, {
      property: "property_name",
      filterType: 'text',
      icon: "tag"
    }, {
      label: "",
      width: 70,
      content: function content(prop) {
        return /*#__PURE__*/React.createElement(NavLink, {
          to: queryStringMod({
            "do": "edit",
            id: prop.id
          })
        }, /*#__PURE__*/React.createElement(Icon, {
          icon: "edit-2"
        }));
      }
    }]
  }));
}

// @ts-ignore
_inject("@media(min-width:501px){.evbw5gen.evbw5gen{left:270px}}", 4200);
_inject("@media(max-width:500px){.ev103ggzd.ev103ggzd{left:0}}", 4200);
_inject("@media(max-width:500px){.ev1qqrqh5.ev1qqrqh5{bottom:50px}}", 4200);